import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import type { VoucherTypeInput } from '@/api/types'
import { vouchersApi } from '@/api/endpoints/vouchers'

export function useVoucherConfig(restaurantId?: number | null) {
  return useQuery({
    queryKey: ['vouchers', restaurantId],
    queryFn: () => vouchersApi.get(restaurantId as number),
    enabled: typeof restaurantId === 'number',
  })
}

export function useSaveVoucherConfig(restaurantId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (types: Array<VoucherTypeInput>) =>
      vouchersApi.save(restaurantId, types),
    onSuccess: () => {
      toast.success('Voucher types saved')
      queryClient.invalidateQueries({ queryKey: ['vouchers', restaurantId] })
    },
    onError: () => {
      toast.error('Failed to save voucher types')
    },
  })
}
